var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42505 14.5999L6.85838 9.16657C7.50005 8.5249 7.50005 7.4749 6.85838 6.83324L1.42505 1.3999",
    stroke: "url(#paint0_linear_560_3215)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_560_3215",
    x1: 3.20423,
    y1: 3.75621,
    x2: 8.93309,
    y2: 8.50161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightColored);
export default __webpack_public_path__ + "static/media/arrow-right-colored.a81027789f53a463cb3237e3f2537f0d.svg";
export { ForwardRef as ReactComponent };